<script setup lang="ts">
const links = useLinks()
const { isMobile } = useDevice()
</script>

<template>
    <div class="navbar">
        <SelfAssessmentContainer />
        <nav>
            <div class="navbar__start">
                <UIButton
                    v-bind="links.login.props()"
                    class="navbar__login-button"
                    as="nav"
                    data-test="nav-bar-button-login"
                >
                    <span>Log ind</span>
                </UIButton>
            </div>

            <div class="navbar__middle">
                <NuxtLink v-bind="links.signup.props()">
                    <NuxtImg
                        class="navbar__logo"
                        provider="cloudflare"
                        preset="local"
                        src="/media/logo/logo-menu.png"
                        :width="isMobile ? 150 : 173"
                        :height="isMobile ? 33 : 38"
                        alt="Spin King"
                    />
                    <!-- Todo: Replace NuxtImg with this when SVG arrives
                    <span
                        class="navbar__logo"
                        title="Spin King"
                    >
                        <component :is="menulogo" />
                    </span> -->
                </NuxtLink>
            </div>

            <div class="navbar__end">
                <UIButton
                    v-bind="links.signup.props()"
                    as="nav"
                    class="navbar__signup-button"
                    data-test="nav-bar-button-signup"
                >
                    <div>
                        <UIIcon
                            v-if="!isMobile"
                            name="login"
                        />
                        <b>Opret konto</b>
                    </div>
                </UIButton>
            </div>
        </nav>
    </div>
</template>

<style scoped lang="scss">
.navbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-image: $nav-bg-image;

    z-index: 10;

    nav {
        display: grid;
        grid-template-areas: 'start middle end';
        grid-template-columns: 0.5fr 1fr 0.5fr;
        align-items: center;
        padding: 0 15px;
        max-width: 1024px;
        margin: 0 auto;
        box-shadow: unset;
        height: 55px;

        @include tablet {
            height: 70px;
        }

        @include desktop {
            max-width: 1280px;
        }
    }

    &__start {
        grid-area: start;
        display: grid;
        align-items: center;
        justify-items: flex-start;
    }

    &__middle {
        position: relative;
        grid-area: middle;
        display: grid;
        align-items: center;
        justify-items: center;
    }

    &__end {
        grid-area: end;
        display: grid;
        align-items: center;
        justify-items: flex-end;
    }

    &__login-button {
        font-size: $font-size-sm;
        font-weight: $text-bold;
        padding: 10px 10px 10px 0;
    }

    &__logo {
        max-height: 45px;
    }

    &__signup-button {
        transform: translateY(4px);
        font-weight: 700;
        padding: 10px 0 10px 10px;

        @include tablet {
            min-width: 150px;
        }
    }
}
</style>
